import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { TREATMENTS } from "../../lib/medskin-data";

export const Treatments = () => {
  return (
    <section id="behandlinger" className="py-24 md:py-36 bg-[#EBE5DF]/40" data-testid="treatments-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#C4A981]"></span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-[#635D56]">Hva vi hjelper med</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-[3.5rem] leading-[1.08] text-[#2C2C2A] tracking-tight font-light" data-testid="treatments-headline">
            Målrettet behandling for hudens <em className="italic text-[#4A4238]">underliggende årsaker</em>.
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#635D56] font-light leading-relaxed">
            Vi spesialiserer oss innen seks kjerneområder. Hver protokoll bygges presist rundt din hud, din historikk og dine mål.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {TREATMENTS.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                to={`/hudutfordringer/${t.pillarSlug}`}
                className="group relative block bg-white p-8 md:p-10 rounded-3xl border border-[#E5E0DA] hover:border-[#C4A981] hover:shadow-[0_20px_50px_-25px_rgba(74,66,56,0.25)] transition-all duration-500"
                data-testid={`treatment-card-${t.id}`}
              >
                <div className="flex items-start justify-between mb-10">
                  <span className="font-serif text-sm text-[#C4A981]">0{i + 1}</span>
                  <span className="rounded-full p-2 border border-[#E5E0DA] group-hover:bg-[#4A4238] group-hover:border-[#4A4238] group-hover:text-[#F7F6F3] transition-all duration-500">
                    <ArrowUpRight size={14} strokeWidth={1.2} />
                  </span>
                </div>
                <h3 className="font-serif text-2xl md:text-[1.6rem] text-[#2C2C2A] leading-tight">{t.title}</h3>
                <p className="mt-4 text-sm md:text-[0.95rem] text-[#635D56] font-light leading-relaxed">{t.description}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
